import { cn } from '@/lib/utils'

interface RichTextProps {
    html: string
    className?: string
}

/**
 * Renders a rich text field from the CMS. Only the site owner writes these
 * fields, so the stored HTML is rendered as is. Styles live in
 * src/styles/rich-text.css.
 */
export const RichText = ({ html, className }: RichTextProps) => {
    return <div className={cn('rich-text', className)} dangerouslySetInnerHTML={{ __html: html }} />
}
